import tippy from 'tippy.js';
export default function footerPopover() {
  const popovers = document.querySelectorAll('.js-location-popover');

  [...popovers].forEach((button) => {
    const {
      location = '',
      telephone = '',
      email = '',
      address = '',
    } = JSON.parse(button.dataset.locationPopover);

    const content = `
      <span class="tippy-title">${location}</span>
      <br>${address}
      <br>${telephone}
      <br>
      <a class="tippy-email" href="mailto:${email}">
        ${email}
      </a>
    `;
    
    tippy(button, {
      content,
      allowHTML: true,
      placement: 'right',
      arrow: true,
      trigger: 'click',
      interactive: true,
      offset: [20, 10],
    });
  });
}
